import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface ITableFiltersProps {
  tableId: string,
  tableType: string,
  filterdata: IFilterButtonData[],
  setFilter: (column: string, values: string[]) => void,
  setSelectedButton: (id: number) => void,
}

export interface IFilterButtonData {
  button: string,
  count: number,
  filters: IFilterData[]
}

export interface IFilterData {
  column: string,
  filterValues: string[],
}

export const TableFilters: FunctionComponent<ITableFiltersProps> = (props) => {
    const intl = useIntl();
    const [activeButton, setActiveButton] = useState(0);
    const getFilterButtons = (f: IFilterButtonData[]) => { 
      if (f) {
        // Define the filter input and handler for the i column
        const buttons: JSX.Element[] = [];

        f.forEach((f: IFilterButtonData, id: number) => {
          // UI for filter box
          buttons.push(
            <button key={'filterbutton' + id} className={'box btn btn-link d-flex flex-column-reverse new' + (activeButton === id ? ' selected' : '')}
              onClick={() => {
                for(let i = 0; i < f.filters.length; i++) {
                  props.setFilter(f.filters[i].column, f.filters[i].filterValues);
                }
                setActiveButton(id);
                props.setSelectedButton(id);
              }}
              aria-controls={props.tableId}
              aria-label={ intl.formatMessage({id: props.tableType + '.' + f.button  + '.arialabel' }, {count: f.count})} >
              <span className="cat">{ intl.formatMessage({id: props.tableType + '.' + f.button})}</span>
              <span className="count">{f.count}<span className="sr-only"><FormattedMessage id="unit.pieces"/></span></span>
            </button>
          )
        })
        return buttons;
      }
      else return <></>
    }

    return (
      <nav className="myfilters d-flex flex-row flex-wrap" aria-label={ intl.formatMessage({ id: 'tablefilters.arialabel' })}>
        {getFilterButtons(props.filterdata)}
      </nav>
    )
};